module.exports = __webpack_public_path__ + "img/dice-3.82d33cd7.svg";